import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { fontFallback } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';

import type { SupportedThirdParty } from '../../../../common/constants/import-type';
import { SectionHeading } from '../../../../common/ui';
import { useContentForThirdParty, useUrlForThirdParty } from '../../../../common/utils';
import { useProjectData } from '../../../../controllers/import-state';
import messages from './messages';

export const FieldsMappingHeader = ({ thirdParty }: { thirdParty: SupportedThirdParty }) => {
	const { formatMessage } = useIntl();
	const { fieldsMappingPageDescription } = useContentForThirdParty(thirdParty);
	const [{ type }] = useProjectData();
	const { fieldURL, customFieldURL } = useUrlForThirdParty(thirdParty, type);

	return (
		<>
			<SectionHeading>{formatMessage(messages.heading)}</SectionHeading>
			{fieldsMappingPageDescription && (
				<Description>
					{formatMessage(fieldsMappingPageDescription, {
						link: (chunks: ReactNode) => (
							<a href={fieldURL} target="_blank">
								{chunks}
							</a>
						),
						customFieldLink: (chunks: ReactNode) => (
							<a href={customFieldURL} target="_blank">
								{chunks}
							</a>
						),
					})}
				</Description>
			)}
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.span({
	display: 'block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/atlaskit-theme -- Ignored via go/DSP-18766
	font: token('font.body', fontFallback.body.medium),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N400),
	marginTop: token('space.100', '8px'),
});
